var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "score_record" },
    [
      _c("h2", [_vm._v(_vm._s(_vm.$t("score.score_detail")))]),
      _vm._v(" "),
      _vm._l(_vm.score_detail_list, function(item, index) {
        return _c("div", { key: index, staticClass: "score_block" }, [
          _c("div", { staticStyle: { width: "200px" } }, [
            _c("div", [_vm._v(_vm._s(_vm._f("timeFilter")(item.create_time)))]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.$t("score_item_map." + item.type)))])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { width: "30px", "margin-right": "10px" } },
            [_vm._v(" + " + _vm._s(item.integral))]
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9994cbba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9994cbba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoreDetail.vue
// module id = null
// module chunks = 